import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "../../layouts/Layout";
import ProtectedRoute from "../Routes/ProtectedRoute";
import { hasPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation2";
import PageLoader from "../../components/ui/pageLoader/PageLoader";
import PropTypes from "prop-types";
import ResetPassword from "../../pages/resetPassword/ResetPassword";
import ForgotPassword from "../../pages/forgotPassword/ForgotPassword";
import TwoFactorAuthentication from "../../pages/twoFactorAuthentication/TwoFactorAuthentication";

const NotFound = React.lazy(() => import("../../pages/errors/NotFound"));
const Login = React.lazy(() => import("../../pages/login/Login"));

const AppRoutes = (props) => {

  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route name="Layout" path="/"
            element={
              <ProtectedRoute>
                <Layout componentRoutes={props.componentRoutes} />
              </ProtectedRoute>
            }
          >
            {props.componentRoutes.map((route) => (
              !hasPermission(route.securityKey)?.noPermission && (
                <Route
                  key={route.path}
                  path={route.path}
                  name={"test"}
                  element={< route.component securityKey={route.securityKey} />}
                />
              )
            ))}

            {/* ------------- Child Routes --------------- */}
            {props.componentRoutes.map((route) => (
              route?.children?.map((childRoute) => (
                <Route
                  key={childRoute.path}
                  path={childRoute.path}
                  element={<childRoute.component securityKey={childRoute.securityKey} />}
                />
              ))
            ))}

          </Route>

          <Route exact name="Login" path="/Login" element={<Login />} />
          <Route exact name="ResetPassword" path="/ResetPassword" element={<ResetPassword />} />
          <Route exact name="ForgotPassword" path="/ForgotPassword" element={<ForgotPassword />} />
          <Route exact name="TwoFactorAuthentication" path="/TwoFactorAuthentication" element={<TwoFactorAuthentication />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

AppRoutes.propTypes = {
  componentRoutes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      component: PropTypes.elementType.isRequired,
      securityKey: PropTypes.string.isRequired,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          path: PropTypes.string.isRequired,
          component: PropTypes.elementType.isRequired,
          securityKey: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
};

export default AppRoutes;
